// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const CALENDAR_BASE_URL = '/api/v1/wechat/calendar';

/**
 * 创建日历
 * @param data 日历数据
 * @param options 请求配置
 */
export async function createCalendar(
  data: OA.CreateCalendarParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.CreateCalendarResult>>(`${CALENDAR_BASE_URL}/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 更新日历
 * @param data 日历数据
 * @param options 请求配置
 */
export async function updateCalendar(
  data: OA.UpdateCalendarParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<{}>>(`${CALENDAR_BASE_URL}/update`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取日历详情
 * @param data 日历ID列表
 * @param options 请求配置
 */
export async function getCalendar(
  data: OA.GetCalendarParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.GetCalendarResult>>(`${CALENDAR_BASE_URL}/get`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除日历
 * @param cal_id 日历ID
 * @param options 请求配置
 */
export async function deleteCalendar(cal_id: string, options?: { [key: string]: any }) {
  return request<OA.ApiResponse<null>>(`${CALENDAR_BASE_URL}/delete`, {
    method: 'DELETE',
    params: { cal_id },
    ...(options || {}),
  });
}

/**
 * 获取本地日历列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function listCalendars(
  params?: OA.ListCalendarParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ListCalendarData>>(`${CALENDAR_BASE_URL}/list`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

const SCHEDULE_BASE_URL = '/api/v1/wechat/calendar/schedule';

/**
 * 获取日程列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function listSchedules(
  params?: OA.ListScheduleParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ListScheduleData>>(`${SCHEDULE_BASE_URL}/list`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/**
 * 取消日程
 * @param data 取消日程参数
 * @param options 请求配置
 */
export async function cancelSchedule(
  data: OA.CancelScheduleParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<null>>(`${SCHEDULE_BASE_URL}/cancel`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

